module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subs-delete",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "subs-delete-subs text-dark"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "subs-delete-subs__loader marg-2-top"
  }, [_c('h3', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.checking_for_substitutes')))]), _vm._v(" "), _c('Loader', {
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "isSmall": true
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
    staticClass: "input-group-subs"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.no_subs_on_lessons')))])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
    staticClass: "marg-1-top"
  }, [_c('div', {
    staticClass: "subs-days-container__header"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.eventsWithSubstitutes.length) + "\n        " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
    staticClass: "select-all-item",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.eventsToRemovedSubs.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "subs-days-container rounded shadow"
  }, _vm._l((_vm.eventsSortedInDays), function(day) {
    return _c('li', [_c('div', {
      staticClass: "day__header"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(day.date))) + ", " + _vm._s(_vm._f("LL")(day.date)))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_sub')))])]), _vm._v(" "), _c('ul', {
      staticClass: "sub-lessons"
    }, _vm._l((day.events), function(event) {
      return _c('li', {
        key: event.event_id,
        staticClass: "d-lesson",
        class: {
          'd-lesson--active': _vm.isInEventsToRemovedSubs(event)
        },
        style: ({
          'border-color': event.color
        }),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.toggleEvent(event)
          }
        }
      }, [_c('div', {
        staticClass: "d-lesson__title"
      }, [_c('span', {
        staticClass: "d-lesson__time"
      }, [_vm._v(_vm._s(_vm._f("LT")(event.start)) + " - " + _vm._s(_vm._f("LT")(event.end)))]), _vm._v("\n              " + _vm._s(event.title) + ", "), _vm._l((_vm.getClasses(event)), function(klass) {
        return _c('span', [_vm._v(" " + _vm._s(klass.name))])
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "sub-selector"
      }, [_vm._l((_vm.getSubstitute(event)), function(sub) {
        return _c('p', {
          staticClass: "sub-name"
        }, [_c('b', [_vm._v(_vm._s(sub.name))])])
      }), _vm._v(" "), _c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': _vm.isInEventsToRemovedSubs(event)
        }
      })], 2)])
    }), 0)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventsToRemovedSubs.length !== 0 || _vm.eventsWithSubstitutes.length !== 0) ? _c('div', {
    staticClass: "subs-delete__footer"
  }, [_c('h4', [_vm._v(_vm._s(_vm.eventsToRemovedSubs.length) + " " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.of')) + " " + _vm._s(_vm.eventsWithSubstitutes.length) + "\n      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_that_will_have_subs_removed')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9af87ee6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsDeleteAbsenceSubs.vue
// module id = 1774
// module chunks = 1